import React, { useState, useEffect } from "react";
import { useAuth } from "./services/AuthContext";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DefaultLayout from "../src/layout/DefaultLayout";
import Page404 from "../src/pages/Page404";
import Page500 from "../src/pages/Page500";
// import ProtectedRoute from "../services/ProtectedRoutes";
import AdminLogin from "../src/pages/AdminLogin";
import "./App.css";
import { Loader, ScrollToTop } from "./services/helper";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HeroSection from "./components/HeroSection";
import DownloadAppSection from "./components/DownloadAppSection";
import WebsiteLayout from "./layout/WebsiteLayout";
import AboutUs from "./pages/About";
import ContactUs from "./pages/ContactUs";
import Home from "./pages/Home";
import TermsAndConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  const { isLoading, user } = useAuth();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setInitialized(true);
    }
  }, [isLoading]);

  if (!initialized) {
    return <Loader />;
  }

  return (
    <BrowserRouter>
      <React.Suspense fallback={<Loader />}>
      <ScrollToTop/>
        <Routes>
          {/* Website Pages */}
          <Route path="/" element={<WebsiteLayout />}>
            <Route index element={<Home />} />
            <Route path="AboutUs" element={<AboutUs />} />
            <Route path="ContactUs" element={<ContactUs />} />
            <Route path="TermsAndConditions" element={<TermsAndConditions/>} />
            <Route path="PrivacyPolicy" element={<PrivacyPolicy/>} />
          </Route>

          <Route
            path="/AdminLogin"
            element={
              <AuthRoute user={user}>
                <AdminLogin />
              </AuthRoute>
            }
          />
          {/* Admin Dashboard */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute user={user}>
                <DefaultLayout />
              </ProtectedRoute>
            }
          />
          {/* Error  */}
          <Route path="*" element={<Page404 />} />
          <Route path="/500" element={<Page500 />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
  function ProtectedRoute({ user, children }) {
    if (!user) {
      // Show a loader or a redirect component
      return <Loader />;
    }
    return children;
  }

  function AuthRoute({ user, children }) {
    if (user) {
      // Show a loader or a redirect component
      return <Loader />;
    }
    return children;
  }
}

export default App;
